import React from "react";
import { useNavigate } from "react-router-dom";
import "./style.css";
import Icon from "../Icon";
import useReveal from "../../hooks/useReveal";

/** `to` matches the routes registered in MainRouter.jsx. */
const industries = [
  {
    icon: "health",
    label: "Healthcare",
    desc: "Compliance-ready platforms for clinics & hospitals",
    accent: "green",
    to: "/industries/healthcare",
  },
  {
    icon: "finance",
    label: "FinTech",
    desc: "Secure, scalable financial data systems",
    accent: "indigo",
    to: "/industries/finance",
  },
  {
    icon: "truck",
    label: "Logistics",
    desc: "Real-time tracking & supply chain automation",
    accent: "amber",
    to: "/industries/logistics",
  },
  {
    icon: "education",
    label: "Education",
    desc: "Smart LMS & student management solutions",
    accent: "blue",
    to: "/industries/education",
  },
  {
    icon: "sparkles",
    label: "AI Automation",
    desc: "Intelligent workflows powered by LLMs",
    accent: "violet",
    to: "/industries/ai-products",
  },
];

export default function IndustriesGrid() {
  const navigate = useNavigate();
  const [gridRef, gridVisible] = useReveal();

  return (
    <section className="industries-grid">
      <div className="section-wrapper">
        <div className="container">
          {/* Section Header */}
          <div className="industries-header">
            <h2 className="industries-title">
              Solutions Tailored for High-Growth Industries
            </h2>
            <p className="industries-subtitle">
              We build specialized software for industries where precision,
              scale, and security matter most.
            </p>
          </div>

          {/* Industries Grid */}
          <div
            className="row gx-4 gy-4 justify-content-center reveal-stagger"
            ref={gridRef}
          >
            {industries.map((industry, index) => (
              <div
                key={industry.label}
                className={`col-6 col-md-4 col-lg reveal ${
                  gridVisible ? "" : "is-hidden"
                }`}
                style={{ "--stagger-index": index }}
              >
                {/* A real button — the card was already styled as clickable
                    (cursor: pointer + arrow) but had no action or keyboard
                    access. Each industry has a route, so wire it up. */}
                <button
                  type="button"
                  className={`industry-card industry-card--${industry.accent} icon-hover`}
                  onClick={() => navigate(industry.to)}
                >
                  <span className="industry-icon-wrap">
                    <Icon
                      name={industry.icon}
                      size={30}
                      className="industry-icon"
                    />
                  </span>
                  <span className="industry-label">{industry.label}</span>
                  <span className="industry-desc">{industry.desc}</span>
                  <span className="industry-arrow" aria-hidden="true">
                    <Icon name="arrowRight" size={18} />
                  </span>
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
